import { AppState, SearchPageKampalaAppState } from '../../../initialStateRegistration';
import { SearchPageKampalaTopSection } from './searchPageKampala.initialState';
import { getHomePage } from '../../homePage/homePageBerlin/homePageBerlin.selectors';

const getSearchPage = (state: AppState) => (state as SearchPageKampalaAppState).template;

export const getSectionData = (key: SearchPageKampalaTopSection) => (state: AppState) => getSearchPage(state)[key];

export const getSectionArticlesByKey = (key: SearchPageKampalaTopSection) => (state: AppState) => getSearchPage(state)[key].articles;

export const getSectionPaginationUrlByKey = (key: SearchPageKampalaTopSection) => (state: AppState) => getSearchPage(state)[key].seeMorePaginationURL;

export const getMetadataDescription = (state: AppState) => getSearchPage(state).metadataDescription;

export const getMetadataTitle = (state: AppState) => getSearchPage(state).metadataTitle;

export const getMetadataImage = (state: AppState) => getHomePage(state).metadataImage;
